import { useState } from 'react'
import {
  InspectorLayersTreeNode,
  useCanvasClickHandler,
  useCanvasMouseMoveHandler,
} from '../sketchSceneLib'
import { isUserInteractionEnabledOnLayer } from './isUserInteractionEnabledOnLayer'

/**
 * Create event handler and react states to display hover and selected layers state.
 */
export function useInspectorOverlayEvents(
  inspectorLayersTreeRootNode: InspectorLayersTreeNode | null,
  /** This should only be enabled when the inspector is open and ready */
  isEnabled: boolean
) {
  const [
    selectedNode,
    setSelectedNode,
  ] = useState<InspectorLayersTreeNode | null>(null)

  const [
    hoveredNode,
    setHoveredNode,
  ] = useState<InspectorLayersTreeNode | null>(null)

  const clickHandler = useCanvasClickHandler(
    inspectorLayersTreeRootNode,
    setSelectedNode,
    isUserInteractionEnabledOnLayer
  )

  const mouseMoveHandler = useCanvasMouseMoveHandler(
    isEnabled,
    inspectorLayersTreeRootNode,
    setHoveredNode,
    isUserInteractionEnabledOnLayer
  )

  const setSelectedNodeExternal = (
    selectedNode: InspectorLayersTreeNode | null
  ) => {
    setSelectedNode(selectedNode)
  }

  return {
    hoveredNode,
    selectedNode,
    /**
     * We need to also be able to set the selected node identifier from outside of events.
     * (using context menu for examples)
     */
    setSelectedNode: setSelectedNodeExternal,
    clickHandler,
    mouseMoveHandler,
  }
}
